module.exports = __webpack_public_path__ + "media/img/apple-icon-57x57-5f761c69a086388e0a2bb50116f5adca.png";